console.log('🎬 main.js: Начало выполнения')

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { setupAxiosInterceptors } from './config/axios'

console.log('📦 main.js: Модули импортированы')

// Глобальная обработка ошибок
window.addEventListener('error', (event) => {
  console.error('🔥 Глобальная ошибка:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('🔥 Необработанный Promise:', event.reason)
})

// Переопределение console
const originalLog = console.log
console.log = function(...args) {
  originalLog.apply(console, ['[LOG]', ...args])
}

// Настройка axios интерсепторов
setupAxiosInterceptors()

createApp(App)
  .use(router)
  .mount('#app')
